import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";

interface Props {
  data: any[];
  xAxis: string;
  yAxis: string;
  domain?: boolean;
  tick?: boolean;
}

const GrafanaLineChart: React.FC<Props> = ({ data, xAxis, yAxis, domain, tick }) => {
  if (!data.length) return <div className="chart-empty">No data available</div>;

  const renderTick = (props: any) => {
    const { x, y, payload } = props;
    const lines = payload.value.split("\n");
    const offset = 8;
  
    return (
      <text x={x} y={y + offset} textAnchor="middle" dominantBaseline="middle">
        {lines.map((line: string, index: number) => (
          <tspan key={index} x={x} dy={index === 0 ? 0 : 15}>
            {line}
          </tspan>
        ))}
      </text>
    );
  };
  

  return (
    <div className="chart-container">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey={xAxis} tick={tick ? renderTick : undefined} />
          <YAxis
            domain={
              domain
                ? [
                    (dataMin: number) => Math.floor(dataMin - 1),
                    (dataMax: number) => Math.ceil(dataMax + 1),
                  ]
                : [0, "auto"]
            }
          />
          <Tooltip />
          <Line
            type="monotone"
            dataKey={yAxis}
            stroke="#4F46E5"
            strokeWidth={2}
            dot={{ r: 1 }}
            activeDot={{ r: 3 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default GrafanaLineChart;